import { render, staticRenderFns } from "./ImageCollectionItemsList.vue?vue&type=template&id=73c6252b&lang=html"
import script from "./ImageCollectionItemsList.vue?vue&type=script&lang=js"
export * from "./ImageCollectionItemsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports